import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../../app/store";
import { useMeQuery } from "../../features/auth/authApi";

export default function PrivateRoute() {
  const access = useSelector((s: RootState) => s.auth.access);
  const user = useSelector((s: RootState) => s.auth.user);
  const meLoaded = useSelector((s: RootState) => s.auth.meLoaded);

  // fetch /me once when we have token but no session loaded
  useMeQuery(undefined, { skip: !access || meLoaded });

  if (!access) return <Navigate to="/login" replace />;
  if (!user && !meLoaded) return null; // could show splash
  if (user?.user_status === "blocked") return <Navigate to="/login" replace />;

  return <Outlet />;
}
